"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ConfirmModal = function ConfirmModal(props) {
  var onClose = props.onClose,
      onConfirm = props.onConfirm,
      isLoading = props.isLoading,
      description = props.description,
      title = props.title,
      confirmTitle = props.confirmTitle,
      _props$confirmVariant = props.confirmVariant,
      confirmVariant = _props$confirmVariant === void 0 ? 'warning' : _props$confirmVariant;
  return (0, _preact.h)(_modal.default, {
    onClose: onClose,
    isControl: true
  }, (0, _preact.h)(_modal.ModalHeader, {
    title: title
  }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("p", null, description)), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)("div", {
    className: "add-edit-status-modal__item__footer"
  }, (0, _preact.h)(_Button.default, {
    title: confirmTitle,
    variant: confirmVariant,
    onClick: onConfirm,
    isLoading: isLoading
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: onClose
  }))));
};

var _default = ConfirmModal;
exports.default = _default;